export const initialState = {
  availableRecipes: [],
  page: 1,
  currentRecipe: {},
  isLoading: false,
  error: null,
  total: null,
};
